module.exports = __webpack_public_path__ + "static/media/Menlo-Regular.9f94dc20.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Menlo-Regular.ttf
// module id = 596
// module chunks = 0